module.exports = __webpack_public_path__ + "img/uk.6279fe1d.png";